import React from 'react';
import { FaCalculator } from 'react-icons/fa';

const CALCULATE_TIMES_SECTION_ID = 'calculated-times-section'

const Form = ({ formData, results, handleSubmit, handleInputChange, error, colors, commonStyles }) => {
  // Scroll to the calculated times section with proper viewport positioning
  // const scrollToCalculatedTimes = () => {
  //   const element = document.getElementById(CALCULATE_TIMES_SECTION_ID)
  //   if (element) {
  //     const headerOffset = document.querySelector('.top-nav')?.offsetHeight || 80
  //     const elementPosition = element.getBoundingClientRect().top
  //     const offsetPosition = elementPosition + window.scrollY - headerOffset

  //     window.scrollTo({
  //       top: offsetPosition,
  //       behavior: 'smooth'
  //     })
  //   }
  // }

  return (
    <div
      id={CALCULATE_TIMES_SECTION_ID}
      style={{...commonStyles.section}}
    >
      <h3
        style={{
        color: colors.text.primary,
        fontSize: '1.2rem',
        fontWeight: '700',
        marginBottom: '20px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }}>
        <FaCalculator />
        Calculate Times
      </h3>

      {/* Display calculated times */}
      <div
        style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '16px',
        marginBottom: '24px'
      }}>
        {/* Estimated Go Time */}
        <div style={{
          backgroundColor: colors.surface,
          padding: '16px',
          borderRadius: '8px',
          border: `1px solid ${colors.border}`
        }}>
          <label style={{
            display: 'block',
            marginBottom: '8px',
            color: '#22c55e',
            fontSize: '1rem',
            fontWeight: '800'
          }}>
            Estimated Go Time
          </label>
          <div style={{
            fontSize: '1.2rem',
            fontWeight: '800',
            color: '#22c55e'
          }}>
            {results?.estimatedRunTime || '-'}
          </div>
        </div>

        {/* Tool 1 Time */}
        <div style={{
          backgroundColor: colors.surface,
          padding: '16px',
          borderRadius: '8px',
          border: `1px solid ${colors.border}`
        }}>
          <label style={{
            display: 'block',
            marginBottom: '8px',
            color: colors.tool1,
            fontSize: '1rem',
            fontWeight: 'bold'
          }}>
            Therapeutic Administration Time #1
          </label>
          <div style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: colors.tool1
          }}>
            {results?.timeToGiveTool1 || '-'}
          </div>
        </div>

        {/* Tool 2 Time */}
        <div style={{
          backgroundColor: colors.surface,
          padding: '16px',
          borderRadius: '8px',
          border: `1px solid ${colors.border}`
        }}>
          <label style={{
            display: 'block',
            marginBottom: '8px',
            color: colors.tool2,
            fontSize: '1rem',
            fontWeight: 'bold'
          }}>
            Therapeutic Administration Time #2
          </label>
          <div style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: colors.tool2
          }}>
            {results?.timeToGiveTool2 || '-'}
          </div>
        </div>

        {/* Tool 3 Time */}
        <div style={{
          backgroundColor: colors.surface,
          padding: '16px',
          borderRadius: '8px',
          border: `1px solid ${colors.border}`
        }}>
          <label style={{
            display: 'block',
            marginBottom: '8px',
            color: colors.tool3,
            fontSize: '1rem',
            fontWeight: 'bold'
          }}>
            Therapeutic Administration Time #3
          </label>
          <div style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: colors.tool3
          }}>
            {results?.timeToGiveTool3 || '-'}
          </div>
        </div>
      </div>

      {/*
      <form onSubmit={(e) => {
        handleSubmit(e)
        scrollToCalculatedTimes()
      }} style={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%'
      }}>
        <button
          type="submit"
          style={{
            backgroundColor: colors.primary,
            color: colors.surface,
            padding: '12px 24px',
            borderRadius: '8px',
            border: 'none',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            width: '100%',
            maxWidth: '300px'
          }}
        >
          Calculate Times
        </button>
      </form>
      */}

      {error && !error.includes('success') && (
        <div
          style={{
            color: colors.error,
            fontSize: '0.9rem',
            marginTop: '12px',
          }}
        >
          <ul style={{ margin: 0, paddingLeft: '1.25rem' }}>
            {error.split(' • ').map((msg, idx) => (
              <li key={idx}>{msg}</li>
            ))}
          </ul>
        </div>
      )}

      {error && error.includes('success') && (
        <div
          style={{
            color: '#059669',
            fontSize: '0.9rem',
            marginTop: '8px',
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
};

export default Form; 